<template lang="pug">
  div(class="billing-overview__card")
    div(class="billing-overview__card-top")
      h4(class="text-16px dark fw-500 pb-1") {{ title }}
      div(class="text-12px fw-300 pb-6") {{ $t('Track usage and plan for future with maximal efficiency') }}
      div(class="billing-overview__items")
        div(class="billing-overview__item gray")
          div(class="text-12px fw-300") {{ $t('Used') }}
          div(class="title-20px fw-500") {{ usedDocuments }}
        div(class="billing-overview__item gray")
          div(class="text-12px fw-300") {{ $t('Left') }}
          div(
            class="title-20px fw-500"
            :class="[hasReachedDocumentLimit ? 'errored' : 'succeed']"
          ) {{ leftDocuments }}
        div(class="billing-overview__item gray")
          div(class="text-12px fw-300") {{ $t('Documents limit') }}
          div(class="title-20px fw-500") {{ availableDocuments }}
    div(class="billing-overview__card-bottom")
      billing-payment-info(
        :info="infoBlock"
        gray
        class="mt-6"
      )
      div(class="billing-overview__actions")
        v-btn(
          outlined
          @click="buyMoreDocuments"
        ) {{ $t('Buy more documents') }}
</template>

<script>
import BillingPaymentInfo from '~/modules/billing/components/billing-payment-info'
import 'moment/locale/uk'
import { PLAN_TYPES } from '~/modules/billing/constants/common'

export default {
  name: 'BillingDocumentsPlanCard',
  components: { BillingPaymentInfo },
  props: {
    plan: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    title() {
      return this.plan?.type === PLAN_TYPES.bonus
        ? this.$t('Your bonus documents')
        : this.$t('Your documents active')
    },
    availableDocuments() {
      return this._.get(this.plan, 'availableDocuments', 0)
    },
    usedDocuments() {
      return this._.get(this.plan, 'usedDocuments', 0)
    },
    leftDocuments() {
      return this.availableDocuments - this.usedDocuments
    },
    hasReachedDocumentLimit() {
      return this.availableDocuments - this.usedDocuments < this.availableDocuments / 10
    },
    infoBlock() {
      return {
        firstRow: {
          label: this.$t('Count'),
          value: `${this.availableDocuments} док.`
        },
        secondRow: {
          label: this.$t('Bought'),
          value: this.$moment.parseZone(this.plan?.startDate).locale('uk').format('D MMMM YYYY')
        },
        summaryRow: {
          label: this.$t('Available until'),
          value: this.$moment.parseZone(this.plan?.endDate).locale('uk').format('D MMMM YYYY'),
          tooltip: {
            text: this.$t('You have a full year for using your documents')
          }
        }
      }
    }
  },
  methods: {
    buyMoreDocuments() {
      this.$emit('slideToLastStep')
    }
  }
}
</script>

<style scoped lang="scss"></style>
